import { render, staticRenderFns } from "./TransferPropertyForm.vue?vue&type=template&id=8c4bc16e&scoped=true&"
import script from "./TransferPropertyForm.vue?vue&type=script&lang=js&"
export * from "./TransferPropertyForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferPropertyForm.vue?vue&type=style&index=0&id=8c4bc16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4bc16e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VItem,VItemGroup,VScrollYTransition})
